import { setLocale } from "yup";

// yup's defaults are English ("x is a required field", "must be a `number` type,
// but the final value was: `NaN`"). Any schema without its own message falls back
// to these, so give the whole app Indonesian defaults once. A message written on
// the schema itself still wins.
export const YUP_LOCALE = {
  mixed: {
    required: "Harus diisi",
    notType: ({ type }) => {
      switch (type) {
        case "number":
          return "Harus berupa angka";
        case "date":
          return "Format tanggal tidak valid";
        case "boolean":
          return "Pilih salah satu";
        default:
          return "Isian tidak valid";
      }
    },
    oneOf: "Pilihan tidak valid",
    defined: "Harus diisi",
  },
  string: {
    email: "Email tidak valid",
    min: ({ min }) => `Minimal ${min} karakter`,
    max: ({ max }) => `Maksimal ${max} karakter`,
    length: ({ length }) => `Harus ${length} karakter`,
    matches: "Format tidak sesuai",
  },
  number: {
    min: ({ min }) => `Minimal ${min}`,
    max: ({ max }) => `Maksimal ${max}`,
    integer: "Harus berupa bilangan bulat",
    positive: "Harus lebih dari 0",
    negative: "Harus kurang dari 0",
    moreThan: ({ more }) => `Harus lebih dari ${more}`,
    lessThan: ({ less }) => `Harus kurang dari ${less}`,
  },
  array: {
    min: ({ min }) => `Minimal ${min} data`,
    max: ({ max }) => `Maksimal ${max} data`,
  },
  date: {
    min: ({ min }) => `Tanggal tidak boleh sebelum ${min}`,
    max: ({ max }) => `Tanggal tidak boleh setelah ${max}`,
  },
};

export const applyYupLocale = () => setLocale(YUP_LOCALE);
